module.exports = __webpack_public_path__ + "img/Cheer Megaphone72.3af830dc.jpg";